<template>
  <div class="case" :style="style" v-on:dblclick="doDbClick">
    <table v-if="vdta.type == 'value'" :class="getLettre()">
      <tr width="100%">
        <td heigth="100%">
          <span v-if="vShowRep" style="border: none !important">
            <!-- <span class="actual">{{ actualValue }}</span> -->
            <div class="rep">{{ vdta.value }}</div>
          </span>
          <!-- <span v-else> -->
          <span v-if="gCreation == true">
            <b-form-input
              :class="actualClass"
              v-model="vdta.value"
              @blur="sendValue"
              :maxlength="1"
            ></b-form-input>
          </span>
          <span v-else>
            <b-form-input
              :class="actualClass"
              v-model="actualValue"
              @blur="sendValue"
              :maxlength="1"
            ></b-form-input>
          </span>
          <!-- </span> -->
        </td>
      </tr>
    </table>
    <div
      v-if="vdta.type == 'label'"
      style="width: 100% !important; height: 100% !important"
    >
      <table class="label">
        <tr v-for="itm of vdta.value" width="100%" :key="itm.l" class="label">
          <td
            :style="{ height: '100% !important', 'font-size': itm.s + 'px' }"
            class="label"
          >
            {{ itm.l }}
          </td>
        </tr>
      </table>
      <span v-for="itm of arrow" :key="itm.arrow">
        <div :style="itm.arrowStyle" v-html="itm.arrow" />
      </span>
    </div>

    <b-modal
      ref="infoCase"
      hide-footer
      title="Info case"
      size="xl"
      :centered="true"
    >
      <b-container>
        <b-form inline>
          <b-input-group prepend="Séparateur horizontal">
            <b-form-select v-model="vdta.hardBorder">
              <b-form-select-option value="left"> gauche </b-form-select-option>
              <b-form-select-option value="bottom"> bas </b-form-select-option>
              <b-form-select-option value=""> aucun </b-form-select-option>
            </b-form-select>
          </b-input-group>

          Liste des libellés :
          <table style="width: 100% !important">
            <tr>
              <td width="130px">
                <b-input-group prepend="Flèche">
                  <b-form-select v-model="l1.a">
                    <b-form-select-option value=""> X </b-form-select-option>
                    <b-form-select-option value="DD">
                      <div v-html="giveMeArrow('DD')" />
                    </b-form-select-option>
                    <b-form-select-option value="BB">
                      <div v-html="giveMeArrow('BB')" />
                    </b-form-select-option>
                    <b-form-select-option value="DB">
                      <div v-html="giveMeArrow('DB')" />
                    </b-form-select-option>
                    <b-form-select-option value="BD">
                      <div v-html="giveMeArrow('BD')" />
                    </b-form-select-option>
                    <b-form-select-option value="BG">
                      <div v-html="giveMeArrow('BG')" />
                    </b-form-select-option>
                    <b-form-select-option value="HD">
                      <div v-html="giveMeArrow('HD')" />
                    </b-form-select-option>
                    <b-form-select-option value="HG">
                      <div v-html="giveMeArrow('HG')" />
                    </b-form-select-option>
                    <b-form-select-option value="GG">
                      <div v-html="giveMeArrow('GG')" />
                    </b-form-select-option>
                    <b-form-select-option value="HH">
                      <div v-html="giveMeArrow('HH')" />
                    </b-form-select-option>
                  </b-form-select>
                </b-input-group>
              </td>
              <td>
                <b-input-group prepend="Libelle">
                  <b-form-input
                    v-model="l1.l"
                    style="text-transform: uppercase"
                  ></b-form-input
                ></b-input-group>
              </td>
              <td>
                <b-input-group prepend="Libelle">
                  <b-form-input v-model="l1.s" type="number"></b-form-input
                ></b-input-group>
              </td>
            </tr>

            <tr>
              <td>
                <b-input-group prepend="Flèche">
                  <b-form-select v-model="l2.a">
                    <b-form-select-option value=""> X </b-form-select-option>
                    <b-form-select-option value="DD">
                      <div v-html="giveMeArrow('DD')" />
                    </b-form-select-option>
                    <b-form-select-option value="BB">
                      <div v-html="giveMeArrow('BB')" />
                    </b-form-select-option>
                    <b-form-select-option value="DB">
                      <div v-html="giveMeArrow('DB')" />
                    </b-form-select-option>
                    <b-form-select-option value="BD">
                      <div v-html="giveMeArrow('BD')" />
                    </b-form-select-option>
                    <b-form-select-option value="BG">
                      <div v-html="giveMeArrow('BG')" />
                    </b-form-select-option>
                    <b-form-select-option value="HD">
                      <div v-html="giveMeArrow('HD')" />
                    </b-form-select-option>
                    <b-form-select-option value="HG">
                      <div v-html="giveMeArrow('HG')" />
                    </b-form-select-option>
                    <b-form-select-option value="GG">
                      <div v-html="giveMeArrow('GG')" />
                    </b-form-select-option>
                    <b-form-select-option value="HH">
                      <div v-html="giveMeArrow('HH')" />
                    </b-form-select-option>
                  </b-form-select>
                </b-input-group>
              </td>
              <td>
                <b-input-group prepend="Libelle">
                  <b-form-input
                    v-model="l2.l"
                    style="text-transform: uppercase"
                  ></b-form-input
                ></b-input-group>
              </td>
              <td>
                <b-input-group prepend="Libelle">
                  <b-form-input v-model="l2.s" type="number"></b-form-input
                ></b-input-group>
              </td>
            </tr>

            <tr>
              <td>
                <b-input-group prepend="Flèche">
                  <b-form-select v-model="l3.a">
                    <b-form-select-option value=""> X </b-form-select-option>
                    <b-form-select-option value="DD">
                      <div v-html="giveMeArrow('DD')" />
                    </b-form-select-option>
                    <b-form-select-option value="BB">
                      <div v-html="giveMeArrow('BB')" />
                    </b-form-select-option>
                    <b-form-select-option value="DB">
                      <div v-html="giveMeArrow('DB')" />
                    </b-form-select-option>
                    <b-form-select-option value="BD">
                      <div v-html="giveMeArrow('BD')" />
                    </b-form-select-option>
                    <b-form-select-option value="BG">
                      <div v-html="giveMeArrow('BG')" />
                    </b-form-select-option>
                    <b-form-select-option value="HD">
                      <div v-html="giveMeArrow('HD')" />
                    </b-form-select-option>
                    <b-form-select-option value="HG">
                      <div v-html="giveMeArrow('HG')" />
                    </b-form-select-option>
                    <b-form-select-option value="GG">
                      <div v-html="giveMeArrow('GG')" />
                    </b-form-select-option>
                    <b-form-select-option value="HH">
                      <div v-html="giveMeArrow('HH')" />
                    </b-form-select-option>
                  </b-form-select>
                </b-input-group>
              </td>
              <td>
                <b-input-group prepend="Libelle">
                  <b-form-input
                    v-model="l3.l"
                    style="text-transform: uppercase"
                  ></b-form-input
                ></b-input-group>
              </td>
              <td>
                <b-input-group prepend="Libelle">
                  <b-form-input v-model="l3.s" type="number"></b-form-input
                ></b-input-group>
              </td>
            </tr>
          </table>
          <b-button variant="danger" size="sm" @click="doClear">
            Effacer
          </b-button>
          &nbsp; - &nbsp;
          <b-button variant="success" size="sm" @click="doCreateLibelle">
            Valider
          </b-button>
        </b-form>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "compCase",
  data() {
    return {
      size: {
        col: 75,
        row: 75,
      },
      vcol: 0,
      vrow: 0,
      vdta: {},
      style: {},
      type: "",

      arrow: "",
      vShowRep: false,
      vAssisted: false,

      gCreation: false,

      actualValue: "",
      actualClass: ["actual", "input"],

      l1: {
        l: "",
        a: "",
        s: 10,
      },
      l2: {
        l: "",
        a: "",
        s: 10,
      },
      l3: {
        l: "",
        a: "",
        s: 10,
      },
    };
  },
  props: ["val", "row", "col", "dta", "showrep", "assisted", "creation"],

  watch: {
    val: {
      handler() {
        if (this.val != undefined) {
          if (this.val == " ") {
            this.actualValue = "";
          } else {
            this.actualValue = this.val.toUpperCase();
          }
        } else {
          this.actualValue = "";
        }
      },
      deep: true,
      immediate: true,
    },
    col: {
      handler() {
        if (this.col != undefined) {
          this.vcol = this.col - 1;
        }
        this.doStyle();
      },
      deep: true,
      immediate: true,
    },
    row: {
      handler() {
        if (this.row != undefined) {
          this.vrow = this.row - 1;
        }
        this.doStyle();
      },
      deep: true,
      immediate: true,
    },
    dta: {
      handler() {
        if (this.dta != undefined) {
          this.vdta = this.dta;

          // if (this.vdta == " ") {
          //   this.vdta = "";
          // }
        } else {
          this.vdta = {
            type: "string",
            value: "",
            hardBorder: false,
          };
          // this.type = "";
        }

        this.doStyle();
        this.doClass();
      },
      deep: true,
      immediate: true,
    },
    showrep: {
      handler() {
        if (this.showrep != undefined) {
          this.vShowRep = this.showrep;
        } else {
          this.vShowRep = false;
        }
      },
      deep: true,
      immediate: true,
    },
    assisted: {
      handler() {
        if (this.assisted != undefined) {
          this.vAssisted = this.assisted;
        } else {
          this.vAssisted = false;
        }
        this.doClass();
      },
      deep: true,
      immediate: true,
    },
    creation: {
      handler() {
        if (this.creation != undefined) {
          this.gCreation = this.creation;
        } else {
          this.gCreation = false;
        }
      },
      deep: true,
      immediate: true,
    },
  },

  created() {},

  mounted() {},

  components: {},

  computed: {},

  methods: {
    getLettre() {
      switch (this.vdta.hardBorder) {
        case "left":
          return "lettre2";
        case "bottom":
          return "lettre3";
        default:
          return "lettre";
      }
    },

    doClass() {
      // console.log(this.vdta, "=>", this.actualValue);
      if (this.vAssisted == true) {
        if (this.vdta.value == this.actualValue && this.actualValue != "") {
          this.actualClass = ["actualOK", "input"];
        } else {
          if (this.actualValue == "") {
            this.actualClass = ["actual", "input"];
          } else {
            this.actualClass = ["actualBAD", "input"];
          }
        }
      } else {
        this.actualClass = ["actual", "input"];
      }
    },

    doStyle() {
      this.style = {
        left: this.vcol * this.size.col - (this.vcol - 1) + "px !important",
        top: this.vrow * this.size.row - (this.vrow - 1) + "px !important",
        width: this.size.row + "px !important",
        height: this.size.col + "px !important",
      };
      if (this.vdta.type == "label") {
        this.style["background-color"] = "beige";
        this.doArrow();
      }
    },

    giveMeArrow(a) {
      switch (a) {
        case "DB":
          return "&#8628;";

        case "DD":
          return "&#8594;";

        case "BD":
          return "&#8627;";

        case "BB":
          return "&#8595;";

        case "BG":
          return "&#8626;";

        case "HD":
          return "&#8625;";

        case "HG":
          return "&#8624;";

        case "GG":
          return "&#8592;";

        case "HH":
          return "&#8593;";

        default:
          return "";
      }
    },

    doArrow() {
      if (this.vdta.type == "label") {
        var t = [];

        for (var o of this.vdta.value) {
          var arrow = "";
          var aStyle = {
            position: "absolute",
            "font-family": "Arial, Helvetica, sans-serif",
            "font-size": "20px",
            "font-weight": "bold",
            "z-index": 1000,
          };

          arrow = this.giveMeArrow(o.a);

          switch (o.a) {
            case "DB":
              aStyle.top = 0 + "px !important";
              aStyle.left = this.size.col - 2 + "px !important";
              break;

            case "DD":
              aStyle.top = 2 + "px !important";
              aStyle.left = this.size.col - 2 + "px !important";
              break;

            case "BD":
              aStyle.left = 2 + "px !important";
              aStyle.top = this.size.row - 6 + "px !important";
              break;

            case "BB":
              aStyle.left = this.size.col / 2 - 7 + "px !important";
              aStyle.top = this.size.row - 10 + "px !important";
              break;

            default:
              arrow = "";
              aStyle = "";
          }
          t.push({
            arrow: arrow,
            arrowStyle: aStyle,
          });

          //   console.log("vue : ", o.l, " => ", this.vcol, "/", this.vrow, " => ", t);
        }
      }
      this.arrow = t;
    },

    sendValue() {
      this.vdta.value =
        typeof this.vdta.value == "string"
          ? this.vdta.value.toUpperCase()
          : this.vdta.value;
      this.actualValue = this.actualValue.toUpperCase();
      var ret = {
        col: this.vcol + 1,
        row: this.vrow + 1,
        val: this.actualValue == "" ? " " : this.actualValue.toUpperCase(),
        dta: this.vdta,
      };
      this.doClass();
      this.$emit("change", ret);
    },

    doDbClick() {
      if (this.gCreation == true) {
        this.l1 = {
          l: "",
          a: "",
          s: 10,
        };
        this.l2 = {
          l: "",
          a: "",
          s: 10,
        };
        this.l3 = {
          l: "",
          a: "",
          s: 10,
        };
        if (this.vdta.type == "label") {
          if (this.vdta.value[0] != undefined) {
            this.l1 = this.vdta.value[0];
            if (this.l1.s == undefined) {
              this.l1.s = 10;
            }
          }
          if (this.vdta.value[1] != undefined) {
            this.l2 = this.vdta.value[1];
            if (this.l2.s == undefined) {
              this.l2.s = 10;
            }
          }
          if (this.vdta.value[2] != undefined) {
            this.l3 = this.vdta.value[2];
            if (this.l3.s == undefined) {
              this.l3.s = 10;
            }
          }
        }
        this.showModal("infoCase");
      }
    },

    doCreateLibelle() {
      if (this.l1.l != "") {
        this.vdta.type = "label";
        this.vdta.value = [];

        // if (this.l1.l != "") {
        this.l1.l = this.l1.l.toUpperCase();
        this.l1.s = parseInt(this.l1.s);
        this.vdta.value.push(this.l1);
      }
      if (this.l2.l != "") {
        this.l2.l = this.l2.l.toUpperCase();
        this.l2.s = parseInt(this.l2.s);
        this.vdta.value.push(this.l2);
      }
      if (this.l3.l != "") {
        this.l3.l = this.l3.l.toUpperCase();
        this.l3.s = parseInt(this.l3.s);
        this.vdta.value.push(this.l3);
      }
      // this.actualValue = "*";

      this.sendValue();
      this.hideModal("infoCase");
      this.doStyle();
      this.doClass();
    },

    doClear() {
      this.vdta.value = "";
      this.hardBorder = false;
      this.vdta.type = "";
      this.actualValue = "";
      this.sendValue();
      this.hideModal("infoCase");
      this.doStyle();
      this.doClass();
    },

    showModal(m) {
      this.$refs[m].show();
    },

    hideModal(m) {
      this.$refs[m].hide();
    },
  },
};
</script>

<style>
.input {
  border: none !important;
  background-color: transparent;
  outline: 0px !important;
  -webkit-appearance: none;
  box-shadow: none !important;
  width: 100% !important;
  height: 100% !important;
  text-align: center;
}

.rep {
  position: absolute;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 20px;
  top: 60%;
  left: 70%;
  font-weight: bold;
  color: lightgray;
}

.actual {
  font-family: fantasy;
  font-size: 30px !important;
  font-weight: normal;
  color: blueviolet !important;
  text-transform: uppercase;
}

.actualOK {
  font-family: fantasy;
  font-size: 30px !important;
  font-weight: normal !important;
  color: green !important;
  text-transform: uppercase;
}

.actualBAD {
  font-family: fantasy;
  font-size: 30px !important;
  font-weight: bold !important;
  color: red !important;
  text-transform: uppercase;
}

.case {
  /* border: solid black; */
  position: absolute;
}

.lettre {
  text-align: center !important;
  vertical-align: middle !important;
  width: 100%;
  height: 100%;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 30px;
  border: 1px solid;
  border-collapse: collapse;
}

.lettre2 {
  text-align: center !important;
  vertical-align: middle !important;
  width: 100%;
  height: 100%;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 30px;
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-right: 1px solid;
  border-left: 3px solid;
  border-collapse: collapse;
}

.lettre3 {
  text-align: center !important;
  vertical-align: middle !important;
  width: 100%;
  height: 100%;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 30px;
  border-top: 1px solid;
  border-bottom: 3px solid;
  border-right: 1px solid;
  border-left: 1px solid;
  border-collapse: collapse;
}

.label {
  text-align: center !important;
  vertical-align: middle !important;
  width: 100% !important;
  height: 100% !important;
  font-family: Arial, Helvetica, sans-serif;
  /* font-size: 9px; */
  font-weight: bold;
  border: 1px solid;
  border-collapse: collapse;
  text-transform: full-width;
}
</style>
